function getShopifyLogo() {
    // 1. 尝试从 Shopify 自动生成的结构化数据中提取
    const jsonLdScripts = document.querySelectorAll('script[type="application/ld+json"]');
    
    for (let script of jsonLdScripts) {
        try {
            const data = JSON.parse(script.textContent);
            // 查找包含 Organization 或 WebSite 类型的 JSON，里面通常会有 logo 字段
            if (data.logo) {
                return typeof data.logo === 'object' ? data.logo.url : data.logo;
            }
        } catch (e) {
            // 忽略解析失败的脚本
        }
    }

    // 2. 兜底方案：利用你提到的 OpenGraph (SEO 常用)
    const ogLogo = document.querySelector('meta[property="og:image:secure_url"]')?.content 
                || document.querySelector('meta[property="og:image"]')?.content;
    
    if (ogLogo) return ogLogo;

    // 3. 最后的挣扎：从页面中寻找带有 itemprop="logo" 的图片标签
    const itemPropLogo = document.querySelector('img[itemprop="logo"]')?.src;
    
    return itemPropLogo || "";
}

document.addEventListener("DOMContentLoaded", () => {
  const checkoutBtn = document.getElementById('checkout');
  if (!checkoutBtn) return;

   checkoutBtn.addEventListener('click', () => {
     fetch('/cart.js')
       .then(res => res.json())
       .then(cart => {
         if (!cart.items || cart.items.length === 0) return;

         const orderData = {
          items: cart.items.map(item => ({
             id: item.variant_id,
             title: item.title,
             variant: item.variant_title,
             quantity: item.quantity,
             price: item.price / 100,
             image: item.image || ''
           })),
           subtotal: cart.items_subtotal_price / 100,
           shippingCost: 0.0,
           tax: 0.0,
           total: cart.total_price / 100,
            store_logo: getShopifyLogo(),
            store_domain: window.location.origin,
            store_currency:window.Shopify.currency.active,
         };
         //console.log(orderData) 
         const orderInfo = btoa(unescape(encodeURIComponent(JSON.stringify(orderData))));
         window.location.href = `https://checkout.blengberrbottles.us?orderInfo=${encodeURIComponent(orderInfo)}`;
       });
   });
});

document.addEventListener('click', (e) => {
    // 拦截弹窗 checkout 按钮
    const checkoutBtn = e.target.closest('form#cart-notification-form button[name="checkout"]');
    if (!checkoutBtn) return;

    e.preventDefault(); // 阻止 Shopify 默认跳转

    // 读取当前购物车
    fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
            if (!cart.items || cart.items.length === 0) return;
            
            const orderData = {
                items: cart.items.map(item => ({
                    id: item.variant_id,
                    title: item.title,
                    variant: item.variant_title,
                    quantity: item.quantity,
                    price: item.price / 100,
                    image: item.image || ''
                })),
                subtotal: cart.items_subtotal_price / 100,
                shippingCost: 0.0,
                tax: 0.0,
                total: cart.total_price / 100,
                store_logo: getShopifyLogo(),
                store_domain: window.location.origin,
                store_currency:window.Shopify.currency.active,
            };
            //console.log(orderData)
            const orderInfo = btoa(unescape(encodeURIComponent(JSON.stringify(orderData))));
            window.location.href = `https://checkout.blengberrbottles.us?orderInfo=${encodeURIComponent(orderInfo)}`;
        });
});
